import { PartnerPlan } from "@/domain/entities/PartnerPlan"
import { BatchResponseDataDTO } from "../dto/BatchResponseDTO"

const toDomain = (data: BatchResponseDataDTO): PartnerPlan => {
    return {
        id: "",
        partnership_id: "",
        codes: [],
        date_start: "",
        date_end: "",
        created_at: "",
        status: "active"
    }
}
export default {
    toDomain
}